import { API } from "../API";
import {
    ILoginFormValues,
    ILoginResponse,
    ILoginResponseHMI,
    ILoginSuperAdminToCorporateFormValues,
} from "../../components/Login/LoginInterfaces";
import axiosInstance from "api/axiosInstance";
import {
    removeToken,
    isTokenAvailable,
    setUser,
    setMachineCenterIdHMI,
    setClusterIdHMI,
    getMachineCenterIdHMI,
    getClusterIdHMI,
    removeMachineCenterIdHMI,
    removeHMIDisplayUnit,
    removeClusterIdHMI,
    getToken,
} from "../../utilities/storageUtilities";

const APIInstance = new API();

export const adminLogin = async (
    values: ILoginFormValues,
    handleUserSet: (id: number) => void,
): Promise<ILoginResponse | unknown> => {
    try {
        const url = `${APIInstance.api_root}/auth/login-admin`;
        const response = (await axiosInstance.post(url, values)) as ILoginResponse;
        const { user } = response.data;
        if (user) {
            setUser(user.user_id);
            handleUserSet(user.user_id);
        }
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const superAdminCorporateLogin = async (
    values: ILoginSuperAdminToCorporateFormValues,
): Promise<ILoginResponse | unknown> => {
    const currentToken = getToken();

    try {
        const url = `${APIInstance.api_root}/auth/login-superadmin-to-corporate`;
        const response = (await axiosInstance.post(url, values, {
            headers: {
                authorization: `Bearer ${currentToken}`,
                "content-type": "application/json",
            },
        })) as ILoginResponse;

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const corporateLogin = async (
    values: ILoginFormValues,
    handleUserSet: (id: number) => void,
): Promise<ILoginResponse | unknown> => {
    try {
        const url = `${APIInstance.api_root}/auth/login-corporate`;
        const response = (await axiosInstance.post(url, values)) as ILoginResponse;
        const { user } = response.data;
        if (user) {
            setUser(user.user_id);
            handleUserSet(user.user_id);
        }
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const HMILogin = async (values: ILoginFormValues): Promise<ILoginResponseHMI | unknown> => {
    try {
        const url = `${APIInstance.api_root}/auth/login-hmi`;
        const response = (await axiosInstance.post(url, values)) as ILoginResponseHMI;
        const { machine_center, cluster } = response.data;
        if (machine_center) {
            setMachineCenterIdHMI(machine_center);
        }
        if (cluster) {
            setClusterIdHMI(cluster.cluster_id);
        }
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const logout = () => {
    const token = isTokenAvailable();
    const machineCenterId = getMachineCenterIdHMI();
    const clusterId = getClusterIdHMI();

    if (token) {
        removeToken();
    }
    if (machineCenterId || clusterId) {
        removeClusterIdHMI();
        removeMachineCenterIdHMI();
        removeHMIDisplayUnit();
    }
};
